/* DeusDream · Perfumes y tecnología se pueden combinar en un mismo pedido.
   - Después de cada agregado al carrito, si quedan mezclados, avisa una vez que llegan en 2 envíos.
   - keepOnly() queda disponible por si se quiere dejar un solo tipo. */
(function () {
  'use strict';
  if (window.DDCartGuard) return;

  const root = () => {
    const r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return r.endsWith('/') ? r : r + '/';
  };
  const nativeFetch = window.fetch.bind(window);

  const isPerfume = (item) => {
    const p = item.properties || {};
    const type = String(item.product_type || '').toLowerCase();
    const title = String(item.product_title || item.title || '').trim();
    return p._dd_perfume === 'true' || type === 'perfume' || type === 'body splash' || (/'$/.test(title) && !/''$/.test(title));
  };

  const getCart = async () => {
    const res = await nativeFetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart');
    return res.json();
  };

  /* Deja solo un tipo: 'perfumes' o 'tech' */
  const keepOnly = async (kind) => {
    const cart = await getCart();
    const updates = {};
    (cart.items || []).forEach((item) => {
      const perf = isPerfume(item);
      if ((kind === 'perfumes' && !perf) || (kind === 'tech' && perf)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return cart;
    const res = await nativeFetch(root() + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
    if (!res.ok) throw new Error('update');
    return res.json();
  };

  /* Aviso suave: perfumes + tecnología se pueden combinar, pero llegan en 2 envíos. */
  let toast, toastTimer;
  const showNotice = () => {
    try { if (sessionStorage.getItem('dd-mixed-notice')) return; sessionStorage.setItem('dd-mixed-notice', '1'); } catch (e) { /* sin storage */ }
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'dd-cartguard';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
      toast.addEventListener('click', (e) => { if (e.target.closest('[data-dd-guard-close]')) toast.hidden = true; });
    }
    toast.innerHTML = '<div class="dd-cartguard__card">' +
      '<span class="dd-cartguard__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg></span>' +
      '<p><b>Perfumes y tecnología llegan en 2 envíos.</b> Podés comprar todo junto: se despachan por separado a la misma agencia. Los perfumes tienen su mínimo de ' + minimumLabel() + '.</p>' +
      '<button type="button" data-dd-guard-close aria-label="Cerrar aviso">×</button></div>';
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 9000);
  };

  const minimumLabel = () => {
    const el = document.querySelector('meta[name="dd-perfume-min"]');
    return (el && el.content) || '$2.500';
  };

  const check = async () => {
    try {
      const cart = await getCart();
      const items = cart.items || [];
      const perf = items.some(isPerfume);
      const other = items.some((i) => !isPerfume(i));
      if (perf && other) showNotice();
    } catch (e) { /* sin acción */ }
  };

  /* Detectar agregados al carrito hechos por cualquier parte del tema */
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = nativeFetch(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then((res) => {
        if (!res || !res.ok) return;
        setTimeout(check, 250);
      }).catch(() => {});
    }
    return p;
  };

  /* Botones del carrito: "Comprar solo perfumes / solo tecnología" */
  document.addEventListener('click', async (e) => {
    const btn = e.target instanceof Element ? e.target.closest('[data-dd-cart-keep]') : null;
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    const fb = document.querySelector('[data-dd-cart-split-feedback]');
    if (fb) fb.textContent = 'Actualizando el carrito…';
    try {
      await keepOnly(btn.dataset.ddCartKeep);
      location.reload();
    } catch (err) {
      btn.removeAttribute('aria-busy');
      if (fb) fb.textContent = 'No se pudo actualizar. Quitá los productos manualmente desde el carrito.';
    }
  });

  window.DDCartGuard = { check: check, keepOnly: keepOnly, isPerfume: isPerfume };
})();
